var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCoffeeShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 70,
    viewBox: "0 0 91 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3736_5376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5003 49H52.5003C58.2971 49 63.0003 44.2969 63.0003 38.5H66.5003C74.2221 38.5 80.5003 32.2219 80.5003 24.5C80.5003 16.7781 74.2221 10.5 66.5003 10.5H23.6253C22.1706 10.5 21.0003 11.6703 21.0003 13.125V38.5C21.0003 44.2969 25.7034 49 31.5003 49ZM66.5003 17.5C70.3612 17.5 73.5003 20.6391 73.5003 24.5C73.5003 28.3609 70.3612 31.5 66.5003 31.5H63.0003V17.5H66.5003ZM71.7174 59.5H15.7831C10.5768 59.5 9.11119 52.5 11.8456 52.5H75.644C78.3784 52.5 76.9346 59.5 71.7174 59.5Z",
    fill: "#D4D8D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3736_5376",
    x: 0.494141,
    y: 0.5,
    width: 90.0059,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.847059 0 0 0 0 0.847059 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3736_5376"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3736_5376",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoffeeShadow);
export default __webpack_public_path__ + "static/media/Icon-coffee-shadow.3213998ae5a3523aeffe1a60f18d2bac.svg";
export { ForwardRef as ReactComponent };